import Container from "../element/container";
import Icon from "../element/icon";

function Bullet({ item }) {
  if (typeof item === "string") return <li>{item}</li>;

  return (
    <li>
      <strong>{item.label}</strong> — {item.text}
    </li>
  );
}

export default function PolicyContent({ policy, children }) {
  const company = policy.company;

  return (
    <article className="policy-content">
      <header className="policy-heading">
        <span className="policy-eyebrow">{company.brand}</span>
        <h2>{policy.title}</h2>
        {policy.summary && <p className="policy-summary">{policy.summary}</p>}

        <Container tag="div" className="policy-meta">
          <span>
            <Icon icon="solar:calendar-linear" />
            Effective {policy.effectiveDate}
          </span>
          <span>
            <Icon icon="solar:document-text-linear" />
            Version {policy.version}
          </span>
          <span>
            <Icon icon="solar:buildings-2-linear" />
            {company.legalName} ({company.registrationNo})
          </span>
        </Container>
      </header>

      {(policy.intro || []).map((text, index) => (
        <p className="policy-intro" key={`intro-${index}`}>
          {text}
        </p>
      ))}

      {children || policy.sections.map((section) => (
        <section className="policy-section" key={section.heading}>
          <h3>{section.heading}</h3>
          {(section.paragraphs || []).map((text, index) => (
            <p key={`p-${index}`}>{text}</p>
          ))}
          {section.bullets?.length > 0 && (
            <ul>
              {section.bullets.map((item, index) => (
                <Bullet item={item} key={`b-${index}`} />
              ))}
            </ul>
          )}
        </section>
      ))}

      <footer className="policy-footer">
        <p>
          {company.legalName} ({company.registrationNo})
        </p>
        <p>{company.address.join(" ")}</p>
        <p>
          {company.email} · {company.phone}
        </p>
      </footer>
    </article>
  );
}
